import { render, staticRenderFns } from "./PaymentTransactionEventShow.vue?vue&type=template&id=1de39af4&"
import script from "./PaymentTransactionEventShow.vue?vue&type=script&lang=js&"
export * from "./PaymentTransactionEventShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports